import { render, staticRenderFns } from "./global-message.vue?vue&type=template&id=328b7348&"
var script = {}
import style0 from "./global-message.vue?vue&type=style&index=0&id=328b7348&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports